import styles from "./category-menu-item.module.css";
import { ReactComponent as ExpandButton } from "../svg/expand-button.svg";
import classNames from "classnames";
import { ReactElement } from "react";
import OverflowLabel from "../../../../../components/OverflowLabel";

interface CategoryMenuItemProps {
  color?: string;
  icon?: any;
  expanded?: boolean;
  expandedLocked?: boolean;
  label?: string;
  typeId?: number;
  onClickItem?(typeId: number): void;
}

const CategoryMenuItem = (props: CategoryMenuItemProps): any => {
  const { onClickItem, typeId, expanded, color, icon, expandedLocked } = props;

  const handleExpandClick = () => {
    if (onClickItem && !expandedLocked && typeId) onClickItem(typeId);
  };

  let iconStyles = {};
  if (color) {
    iconStyles = { fill: color };
  }

  return (
    <div className={styles["category-menu-item"]}>
      <div
        className={styles["color-marker"]}
        style={{ backgroundColor: color }}
      />
      <div
        className={classNames(styles["expanded-button"], {
          [styles["toggled"]]: expanded,
          [styles["expandedLocked"]]: expandedLocked,
        })}
      >
        {expanded !== null && (
          <ExpandButton
            className={styles["button-icon"]}
            onClick={handleExpandClick}
          />
        )}
      </div>
      <div className={styles["icon"]} style={iconStyles}>
        {icon as ReactElement}
      </div>

      <div className={styles["name"]} style={{ color: "rgba(0,0,0,0.8)" }}>
        <OverflowLabel text={props.label!} />
      </div>
    </div>
  );
};

export default CategoryMenuItem;
